module.exports = {
      id: "filter-usage",
      viewBox: "0 0 8 8",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#filter",
      toString: function () {
        return this.url;
      }
    }